import React from 'react';

import styles from "../styles/entity-mega-header-module.module.scss";
import classNames from "classnames";
import {FollowSelection} from "../../../../../core/components/entity-selection/follow-selection/follow-selection";
import {useThemeColor} from "../../../../../infrastructure/hooks/useThemeColor";
import {COLORS} from "../../../../../core/app/consts/colors";
import {ENTITY_MEGA_HEADER} from "../entity-mega-header-module.consts";
import {EntityMegaHeaderModuleDescriptionTooltip} from "./entity-mega-header-module.description-tooltip";

export const EntityMegaHeaderModuleTitle = ({controller, entity, descriptionHeader}) => {
  const {device} = controller;
  const {isSmallView} = device;

  const tooltipProps = {
    entity,
    controller,
    descriptionHeader
  }

  const followProps = {
    color: useThemeColor(COLORS.textSecondary),
    size: ENTITY_MEGA_HEADER.POPULARITY_ICON_SIZE,
    descriptionEntity: descriptionHeader,
    containerClassName: styles.follow_container,
    followClassName: styles.follow_button,
    followActiveClassName: styles.follow_active_button,
    popularityClassName: styles.follow_popularity,
  }

  return (
    !isSmallView ? <div className={classNames(styles.title_container)}>
      <EntityMegaHeaderModuleDescriptionTooltip {...tooltipProps}/>
      {
        descriptionHeader ? <FollowSelection {...followProps}/> : null
      }
    </div> : null
  )
};
